import { HiSpeakerphone } from 'react-icons/hi';
import { RiTimerFill } from 'react-icons/ri';
import { MdReportProblem } from 'react-icons/md';
import { IoIosPeople, IoIosBasketball } from 'react-icons/io';
import { FaCrown, FaQuestion } from 'react-icons/fa';
import { BsFillAlarmFill } from 'react-icons/bs';
import { BiCodeAlt } from 'react-icons/bi';
import { GiRead, GiCook } from 'react-icons/gi';
import { SiYourtraveldottv } from 'react-icons/si';
import { IoGameController } from 'react-icons/io5';

export const interpersonalSkills = [
  {
    id: 1,
    icon: <HiSpeakerphone />,
    label: 'Communication',
    color: 'slateblue',
  },
  {
    id: 2,
    icon: <FaQuestion />,
    label: 'Decision Making',
    color: 'coral',
  },
  {
    id: 3,
    icon: <FaCrown />,
    label: 'Leadership',
    color: 'gold',
  },
  {
    id: 4,
    icon: <IoIosPeople />,
    label: 'Teamwork',
    color: 'deeppink',
  },
  {
    id: 5,
    icon: <MdReportProblem />,
    label: 'Problem Solving',
    color: 'red',
  },
  {
    id: 6,
    icon: <BsFillAlarmFill />,
    label: 'Time Management',
    color: 'cornflowerblue',
  },
  {
    id: 7,
    icon: <RiTimerFill />,
    label: 'Punctuality',
    color: 'aqua',
  },
];

export const interests = [
  {
    id: 1,
    icon: <BiCodeAlt />,
    label: 'Coding',
    color: 'deeppink',
  },
  {
    id: 2,
    icon: <IoGameController />,
    label: 'Gaming',
    color: 'darkcyan',
  },
  {
    id: 3,
    icon: <GiRead />,
    label: 'Reading',
    color: 'palevioletred',
  },
  {
    id: 4,
    icon: <SiYourtraveldottv />,
    label: 'Travelling',
    color: 'thistle',
  },
  {
    id: 5,
    icon: <IoIosBasketball />,
    label: 'Basketball',
    color: 'chocolate',
  },
  {
    id: 6,
    icon: <GiCook />,
    label: 'Cooking',
    color: 'crimson',
  },
];
